module.exports = __webpack_public_path__ + "static/media/icon-www.40b553cb.svg";